// removed by extract-text-webpack-plugin
module.exports = {"container":"upload-inline-tabs__container___75k8M"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/upload-documents/upload-inline-tabs.scss
// module id = 1374
// module chunks = 0